/**
 * The message LiftCloud gave for a failed API client request, for showing to
 * the operator as it is: it names what to change ("The role does not belong
 * to the External's organization", "An API client cannot hold the MASTER
 * ADMIN role"). Handlers answer `{ status, message }`, a few answer a bare
 * string, and a network failure has no body at all -- then fallback is used.
 */
export default function apiClientErrorMessage(error: unknown, fallback: string): string {
  const e = error as { data?: unknown; error?: unknown } | undefined;
  const data = e?.data as { message?: unknown; error?: unknown } | string | undefined;

  if (typeof data === "string" && data.trim() !== "") return data;
  if (data && typeof data === "object") {
    if (typeof data.message === "string" && data.message.trim() !== "") return data.message;
    if (typeof data.error === "string" && data.error.trim() !== "") return data.error;
  }
  if (typeof e?.error === "string" && e.error.trim() !== "") return e.error;

  return fallback;
}
